import { Data } from '@angular/router';

import { PlatformPermission } from '../models/permission.model';
import { PermissionMatchMode, RoutePermissionData } from '../models/route-permission-data.model';

export function withRoutePermissions(
  permissions: ReadonlyArray<PlatformPermission>,
  mode: PermissionMatchMode = 'all'
): Data {
  const routePermissionData: RoutePermissionData = {
    permissions,
    mode
  };

  return {
    permissions: routePermissionData.permissions,
    permissionMode: routePermissionData.mode
  };
}
